// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';
import type { CategoryType, LinkType, LinkGroupType } from '../types';
import ExpanderAnimation from '../../../../../internal/ExpanderAnimation';

type PropTypes = {|
  categories: Array<CategoryType>,
|};

const Links = (props: { links: Array<LinkType> }) => (
  <ul className={styles.linkContainer}>
    {props.links &&
      props.links.map(({ name: linkName, href }, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li className={styles.link} key={index}>
          <a href={href}>{linkName}</a>
        </li>
      ))}
  </ul>
);

const LinkGroup = (props: { linkGroups: Array<LinkGroupType> }) => {
  const [open, toggle] = React.useState(null);

  return (
    <ul>
      {props.linkGroups.map(({ name, links }, index2) => {
        const onClick = () => {
          toggle(open === name ? null : name);
        };

        return (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index2}>
            <button
              className={cx(styles.linkGroup, open === name && styles.isOpen)}
              onClick={onClick}
            >
              {name}
            </button>
            <ExpanderAnimation open={open === name}>
              <Links links={links} />
            </ExpanderAnimation>
          </li>
        );
      })}
    </ul>
  );
};

export default (props: PropTypes) => {
  return (
    <ul className={styles.menu}>
      {props.categories.map((category, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li className={styles.categoryContainer} key={index}>
          <span className={styles.categoryTitle}>{category.name}</span>
          {category.links && <Links links={category.links} />}
          {category.linkGroups && <LinkGroup linkGroups={category.linkGroups} />}
        </li>
      ))}
    </ul>
  );
};
